import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { BillDetails, billsApi } from '../api/billsApi';
import { BillInvoiceHtmlViewer } from '../components/bills/BillInvoiceHtmlViewer';
import { ReceiptHtmlViewer, printReceipt } from '../components/receipt/ReceiptHtmlViewer';
import { receiptPrintButtonLabel } from '../utils/receiptPrintLabel';

const BillInvoice: React.FC = () => {
  const { billId } = useParams<{ billId: string }>();
  const [billDetails, setBillDetails] = useState<BillDetails | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!billId) return;
      try {
        setLoading(true);
        const details = await billsApi.getBillDetails(billId);
        setBillDetails(details);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [billId]);

  const handlePrint = () => {
    if (billDetails?.status === 'PAID' && billId) {
      printReceipt(billId);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-white border-b shadow-sm sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 min-w-0">
            <Link
              to="/transaction-report"
              className="text-cyan-600 hover:text-cyan-800 text-sm font-medium whitespace-nowrap"
            >
              ← Chi tiết phiếu thu
            </Link>
            {billDetails?.receiptNumber && (
              <span className="text-sm text-gray-600 truncate hidden sm:inline">
                Mã phiếu thu: <strong>{billDetails.receiptNumber}</strong>
              </span>
            )}
          </div>
          <button
            onClick={handlePrint}
            disabled={loading || billDetails?.status !== 'PAID'}
            className="inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-600 disabled:opacity-50 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            {receiptPrintButtonLabel(billDetails?.receiptPrintCopyCount)}
          </button>
        </div>
      </div>

      <div className="max-w-5xl mx-auto p-4">
        {loading ? (
          <div className="text-center py-16 text-gray-600">Đang tải phiếu thu...</div>
        ) : !billDetails ? (
          <div className="text-center py-16 text-gray-500 bg-white rounded-lg shadow-sm">
            Không tìm thấy hóa đơn
          </div>
        ) : billDetails.status !== 'PAID' ? (
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <BillInvoiceHtmlViewer billId={billId!} minHeight="calc(100vh - 120px)" />
          </div>
        ) : billId ? (
          <div className="bg-white rounded-lg shadow-sm overflow-hidden">
            <ReceiptHtmlViewer billId={billId} minHeight="calc(100vh - 120px)" />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BillInvoice;
